import { useMemo } from "react";

import { useUser } from "@components/user-context";
import { makeUniversalBenchmarksAdoptableMetrics } from "@north-beam/nb-client-side";
import {
  type INBAccountingMode,
  type IMCAttributionWindowDays,
} from "@north-beam/nb-common";

export const useAdoptableMetrics = (
  attributionModel: string,
  attributionWindow: IMCAttributionWindowDays,
  accountingMode: INBAccountingMode,
) => {
  const { user } = useUser();

  const aw = accountingMode === "cash" ? "infinity" : attributionWindow;

  return useMemo(() => {
    const metrics = makeUniversalBenchmarksAdoptableMetrics(
      attributionModel,
      aw,
      accountingMode,
      user as any,
    );

    return {
      rev: { ...metrics.rev, id: metrics.rev.metadata?.overviewPageMetricId },
      txns: {
        ...metrics.txns,
        id: metrics.txns.metadata?.overviewPageMetricId,
      },
      roas: { ...metrics.roas, id: metrics.rev.metadata?.overviewPageMetricId },
      spend: {
        ...metrics.spend,
        id: metrics.spend.metadata?.overviewPageMetricId,
      },
      metrics: metrics.metrics.map((metric) => {
        return {
          ...metric,
          id: metric.metadata?.overviewPageMetricId,
        };
      }),
    };
  }, [attributionModel, aw, accountingMode, user]);
};
